import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReCaptcha from 'components/Captcha/ReCaptcha';

import {
  changeFieldEmail,
  changeFieldVerifyCode,
  selectFieldEmail,
  selectFieldVerifyCode,
  sendFormRequest,
  selectMessage,
  selectRequestState
} from 'mt-react-common/modules/users/common/reducers/forms/requestPasswordResetForm';
import ButtonDefault from '../../Common/Buttons/ButtonDefault';

const requestPasswordResetFormRN = 'usersModule.forms.requestPasswordResetForm';

class ForgetPassword extends Component {
  handleSubmit = async event => {
    event.preventDefault();
    this.props.sendFormRequest();
  };

  handleChangeField = async event => {
    switch (event.target.name) {
      case 'email':
        this.props.changeFieldEmail(event.target.value);
        break;
      default:
        break;
    }
  };

  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    if (this.props.requestState.hasSuccessQuery) {
      return (
        <div className="alert alert-success">
          <span>{this.props.selectMessage}</span>
        </div>
      );
    }
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div
            className={`form-group ${
              hasError(this.props.selectFieldEmail.errors) ? 'has-error' : ''
            }`}
          >
            <label className="control-label sr-only" htmlFor="forget-email">
              E-mail
            </label>
            <input
              onChange={this.handleChangeField}
              type="email"
              className="form-control input-lg"
              id="forget-email"
              placeholder="E-mail"
              name="email"
              value={this.props.selectFieldEmail.value}
            />
            {errorDesc(this.props.selectFieldEmail.errors)}
          </div>
          <div
            className={`form-group ${
              hasError(this.props.selectFieldVerifyCode.errors)
                ? 'has-error'
                : ''
            }`}
          >
            <ReCaptcha
              requestStateOfForm={this.props.requestState}
              changeCaptchaValue={value =>
                this.props.changeFieldVerifyCode(value)
              }
            />
            {errorDesc(this.props.selectFieldVerifyCode.errors)}
          </div>
          <ButtonDefault
            type="submit"
            buttonTitle={'Восстановить пароль'}
            showLoading={this.props.requestState.hasInProgress}
            disabled={this.props.requestState.hasInProgress}
          />
        </form>
      </div>
    );
  }
}

ForgetPassword.propTypes = {
  // CONNECT
  selectMessage: PropTypes.string.isRequired,
  selectFieldEmail: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  selectFieldVerifyCode: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,

  changeFieldEmail: PropTypes.func.isRequired,
  changeFieldVerifyCode: PropTypes.func.isRequired,
  sendFormRequest: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  selectFieldEmail: selectFieldEmail(state, requestPasswordResetFormRN),
  selectFieldVerifyCode: selectFieldVerifyCode(
    state,
    requestPasswordResetFormRN
  ),
  requestState: selectRequestState(state, requestPasswordResetFormRN),
  selectMessage: selectMessage(state, requestPasswordResetFormRN)
});

const mapDispatchToProps = dispatch => ({
  changeFieldEmail: value =>
    dispatch(changeFieldEmail(requestPasswordResetFormRN, value)),
  changeFieldVerifyCode: value =>
    dispatch(changeFieldVerifyCode(requestPasswordResetFormRN, value)),
  sendFormRequest: () => dispatch(sendFormRequest(requestPasswordResetFormRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgetPassword);



// WEBPACK FOOTER //
// ./src/components/UserAccount/ForgetPassword/ForgetPassword.js